"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKSlide = void 0;
var react_1 = __importDefault(require("react"));
var common_1 = require("../../common");
var __1 = require("../../");
require("./GKSlide.css");
var GKSlideDef = function (props, ref) {
    // Set up props and variables.
    var name = "gk-slide";
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: name,
    }), _b = _a.activeSlide, activeSlide = _b === void 0 ? 0 : _b, slides = _a.slides, _c = _a.to, to = _c === void 0 ? "left" : _c, passthroughProps = __rest(_a, ["activeSlide", "slides", "to"]);
    // States
    var _d = react_1.default.useState({ width: 0, height: 0 }), parentDim = _d[0], setParentDim = _d[1];
    var _e = react_1.default.useState(activeSlide), active = _e[0], setActive = _e[1];
    // Responsive animation direction.
    var dir = (0, __1.useResponsive)(to);
    // Ref to the container div.
    var parentRef = react_1.default.useRef(null);
    // This mutation observer's job is to resize the slide if its content changes
    // This prevents the slide from clipping the right edge of the child if a scrollbar appears
    // Copypasta from https://github.com/imbhargav5/rooks/blob/main/src/hooks/useMutationObserver.ts
    react_1.default.useEffect(function () {
        // Create an observer instance linked to the callback function
        if (parentRef.current) {
            var observer_1 = new MutationObserver(function () {
                resizeSlidesToFitParent();
            });
            // Start observing the target node for configured mutations
            observer_1.observe(parentRef.current, { subtree: true, childList: true });
            return function () {
                observer_1.disconnect();
            };
        }
        return;
    }, []);
    // Effect to update parent dimensions state, since it's used in calcs.
    var resizeSlidesToFitParent = function () {
        var _a, _b;
        return setParentDim({
            width: ((_a = parentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0,
            height: ((_b = parentRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0,
        });
    };
    react_1.default.useEffect(function () {
        resizeSlidesToFitParent();
        window.addEventListener("resize", resizeSlidesToFitParent);
        return function () { return window.removeEventListener("resize", resizeSlidesToFitParent); };
    }, [slides]);
    // Effect to update the active slide in state when props change
    react_1.default.useEffect(function () {
        if (activeSlide !== undefined) {
            setActive(activeSlide);
        }
    }, [activeSlide]);
    // Determine the slide transform based on the "to" direction
    var getSlideTransform = function () {
        var transform = "translate";
        switch (dir) {
            case "left":
                transform += "X(" + parentDim.width * -active;
                break;
            case "right":
                transform +=
                    "X(" +
                        (-parentDim.width * (slides.length - 1) + parentDim.width * active);
                break;
            case "top":
                transform += "Y(" + parentDim.height * -active;
                break;
            case "bottom":
                transform +=
                    "Y(" +
                        (-parentDim.height * (slides.length - 1) + parentDim.height * active);
                break;
            default:
                transform += "X(" + parentDim.width * -active;
        }
        return (transform += "px)");
    };
    // Set up the methods to pass back via ref
    var previous = function () {
        setActive(active > 0 ? active - 1 : slides.length - 1);
    };
    var next = function () {
        setActive(active < slides.length - 1 ? active + 1 : 0);
    };
    react_1.default.useImperativeHandle(ref, function () { return ({ active: active, previous: previous, next: next }); });
    return (react_1.default.createElement("div", __assign({}, passthroughProps, { ref: parentRef }),
        react_1.default.createElement("div", { className: name + "-slides to-" + dir, "data-qa": name + "--slides", style: {
                transform: getSlideTransform(),
                width: dir === "left" || dir === "right"
                    ? parentDim.width * slides.length
                    : undefined,
                height: dir === "top" || dir === "bottom"
                    ? parentDim.height * slides.length
                    : undefined,
            } }, slides)));
};
/**
 * A generic "slide" component that takes an array of elements to slide
 * and handles animation in one of 4 directions.
 */
exports.GKSlide = react_1.default.forwardRef(GKSlideDef);
exports.default = exports.GKSlide;
